import React from 'react'

function Socials() {
  return (
    <div className="home__social">
        <a href="https://www.linkedin.com/in/jarry-abbas-naqvi/" className="home__social-icon" target="_blank">
            <i className="uil uil-linkedin"></i>
        </a>
        <a href="https://www.behance.net/jarryabbas2" className="home__social-icon" target="_blank">
            <i className="uil uil-behance"></i>
        </a>
        <a href="https://www.instagram.com/jarryabbas_101/" className="home__social-icon" target="_blank">
            <i className="uil uil-instagram"></i>
        </a>

        <a href="https://www.facebook.com/jarry.abbas1" className="home__social-icon" target="_blank">
            <i className="uil uil-facebook-f"></i>
        </a>

        <a href="https://github.com/jarryabbas110" className="home__social-icon" target="_blank">
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Socials